// How big a future trigger's pie is drawn: its area grows with how far it would move the
// forecast, relative to the forecast's most consequential trigger.
import { signpostShift } from "./signposts.js";

export const PIE_MIN_D = 14;
export const PIE_MAX_D = 34;
// Below this many points of shift, the biggest trigger is not drawn at full size: a forecast
// whose triggers all barely move it keeps small pies.
const SHIFT_FLOOR = 5;

/**
 * A function from trigger to pie diameter (px) for one forecast's live triggers. Area is
 * proportional to shift, so the diameter grows with its square root. A trigger whose shift is
 * unknown is drawn a little under the middle size.
 * @param {Array<object>|null|undefined} events the forecast's triggers
 * @param {number|null} [probability] the forecast's P(Yes), for yes/no questions
 * @returns {(ev: object) => number}
 */
export function triggerDiameterFor(events, probability = null) {
  const shifts = (events || [])
    .filter((ev) => ev && !ev.isPast)
    .map((ev) => signpostShift(ev, probability))
    .filter((v) => typeof v === "number" && Number.isFinite(v));
  const max = Math.max(SHIFT_FLOOR, ...shifts);
  return (ev) => {
    const shift = signpostShift(ev, probability);
    const frac =
      typeof shift === "number" && Number.isFinite(shift) ? Math.min(1, shift / max) : 0.3;
    return Math.round(PIE_MIN_D + (PIE_MAX_D - PIE_MIN_D) * Math.sqrt(frac));
  };
}
